import React from "react";
import { BsCheckCircleFill } from "react-icons/bs";
import Button from "../../../../components/Button";
import { theme } from "../../../../theme";
import {
  StyledAmount,
  StyledFeatureList,
  StyledPricingAction,
  StyledPricingBody,
  StyledPricingCard,
  StyledPricingHeader,
} from "./styled";

interface Props {
  title: string;
  subtitle: string;
  price: number;
  originalPrice: number;
  active: boolean;
  options: string[];
  buttonText?: string;
  onSubscribe: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  subscribed?: boolean;
}

const PricingItem: React.FC<Props> = ({
  title,
  subtitle,
  price,
  originalPrice,
  active,
  options,
  buttonText = "Subscribe",
  onSubscribe,
  subscribed,
}) => {
  return (
    <StyledPricingCard active={active}>
      <StyledPricingHeader>
        <h2>
          {title}
          {subscribed && <BsCheckCircleFill fill={"green"} />}
        </h2>
        <span>{subtitle}</span>
      </StyledPricingHeader>
      <StyledPricingBody>
        <StyledAmount active={active}>
          ₹{price}
          {price ? (
            <>
              <span>₹{originalPrice}</span>
              <span>
                {(100 - (price / originalPrice) * 100).toFixed(0)}% OFF
              </span>
            </>
          ) : null}
        </StyledAmount>
        <StyledFeatureList>
          {options.map((o, i) => {
            return (
              <li key={i}>
                <BsCheckCircleFill fill={active ? "#fff" : "#000"} />

                <span>{o}</span>
              </li>
            );
          })}
        </StyledFeatureList>
      </StyledPricingBody>
      <StyledPricingAction>
        <Button
          active={active}
          style={{
            border: active ? `1px solid ${theme.textColor.primaryWhite}` : "",
          }}
          label={subscribed ? "Already Subscribed" : buttonText}
          onClick={(e) => {
            onSubscribe(e);
          }}
        />
      </StyledPricingAction>
    </StyledPricingCard>
  );
};

export default PricingItem;
